import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { CheckItem } from "../../../../components/checkbox-block/checkbox-block.component";
import { ModalService } from "../../../../services/modal.service";
import {
	userPermissionList,
	rolePermissionList,
	virtualPosPermissionList,
	paymentLinksPermissionList,
	savedCardPermissionList,
	supportPermissionList,
	recurringPaymentPermissionList,
	refundPermissionList,
	paymentPermissionList,
	terminalsPermissionList,
	p2pPermissionList,
	infoPermissionList,
	paymentViewPermissionList,
	analyticsPermissionList,
} from "../../constants/permission-list";
import { EditRoleDto, PermissionDto, RoleDetailDto } from "../../models/role-models";
import { Subject, Subscriber, Subscription } from "rxjs";
import { RoleDataService } from "../../services/role-data.service";
import { RoleDetailUpdateService } from "../../services/role-detail-update.service";
import { CheckAllProps } from "src/app/components/checkbox-block/checkbox-model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { notSymbolValidator } from "src/app/validators/not-symbol.validator";

@Component({
	selector: "app-edit-role-dialog",
	templateUrl: "./edit-role-dialog.component.html",
	styleUrls: ["./edit-role-dialog.component.scss"],
})
export class EditRoleDialogComponent implements OnInit, OnDestroy {
	@Input() roleDetail$: Subject<RoleDetailDto> | undefined;

	@Output() roleEditSuccess: EventEmitter<void> = new EventEmitter<void>();

	roleDetail: RoleDetailDto | undefined | null;

	roleId!: number;

	aSub: Subscription | undefined;

	isSending = false;

	userPermissionList: CheckItem[] = [];
	rolePermissionList: CheckItem[] = [];
	virtualPosPermissionList: CheckItem[] = [];
	paymentLinksPermissionList: CheckItem[] = [];
	savedCardPermissionList: CheckItem[] = [];
	supportPermissionList: CheckItem[] = [];
	recurringPaymentPermissionList: CheckItem[] = [];
	refundPermissionList: CheckItem[] = [];
	paymentPermissionList: CheckItem[] = [];
	terminalsPermissionList: CheckItem[] = [];
	p2pPermissionList: CheckItem[] = [];
	infoPermissionList: CheckItem[] = [];
	paymentViewPermissionList: CheckItem[] = [];
	analyticsPermissionList: CheckItem[] = [];

	permissionList: CheckItem[][] = [];

	form!: FormGroup;

	constructor(
		private modalService: ModalService,
		private roleDataService: RoleDataService,
		private roleDetailUpdateService: RoleDetailUpdateService
	) {
		this.permissionList = [
			(this.userPermissionList = userPermissionList),
			(this.rolePermissionList = rolePermissionList),
			(this.virtualPosPermissionList = virtualPosPermissionList),
			(this.paymentLinksPermissionList = paymentLinksPermissionList),
			(this.savedCardPermissionList = savedCardPermissionList),
			(this.supportPermissionList = supportPermissionList),
			(this.recurringPaymentPermissionList = recurringPaymentPermissionList),
			(this.refundPermissionList = refundPermissionList),
			(this.paymentPermissionList = paymentPermissionList),
			(this.terminalsPermissionList = terminalsPermissionList),
			(this.p2pPermissionList = p2pPermissionList),
			(this.infoPermissionList = infoPermissionList),
			(this.paymentViewPermissionList = paymentViewPermissionList),
			(this.analyticsPermissionList = analyticsPermissionList),
		];
	}

	ngOnInit() {
		this.initForm();
		this.initPermissionList();
	}

	initForm() {
		this.form = new FormGroup({
			roleName: new FormControl("", [Validators.required, notSymbolValidator()]),
		});
	}

	ngOnDestroy() {
		this.aSub?.unsubscribe();
	}

	initPermissionList() {
		this.aSub = this.roleDetailUpdateService.roleDetailUpdate.subscribe({
			next: (res) => {
				if (res) {
					this.clearPermission();
					this.roleDetail = res;
					this.form.patchValue({
						roleName: res.name,
					});
					this.roleId = res.id;
					this.setCheckPermission();
				} else {
					this.clearPermission();
					this.roleDetail = null;
					this.form.patchValue({
						roleName: "",
					});
					this.setCheckPermission();
				}
			},
		});
	}

	get roleNameFormatError() {
		return this.form.get("roleName")?.hasError("symbolNotValid");
	}

	get roleNameRequiredError() {
		return this.form.get("roleName")?.hasError("required");
	}

	clearPermission() {
		this.permissionList.forEach((item) => {
			item.forEach((roleItem) => {
				roleItem.state = false;
			});
		});
	}

	setCheckPermission() {
		this.permissionList.forEach((item) => {
			item.forEach((roleItem) => {
				if (this.roleDetail?.rolePrivileges) {
					this.roleDetail.rolePrivileges.forEach((roleDetailItem) => {
						if (roleDetailItem.id === roleItem.id) {
							roleItem.state = true;
						}
					});
				}
			});
		});
	}

	closeModal() {
		this.modalService.closeModal();
	}

	checkboxChange(checkItem: CheckItem) {
		const itemList = this.permissionList.find((el) => el.includes(checkItem));

		if (paymentLinksPermissionList?.includes(checkItem) && itemList && checkItem.id === itemList[0].id) {
			this.paymentPermissionList = [...this.paymentPermissionList];
			this.paymentPermissionList[0].state = true;
		}

		// if (checkItem.state === false && paymentLinksPermissionList?.includes(checkItem) && itemList && checkItem.id === itemList[0].id) {
		// 	this.paymentPermissionList = [...this.paymentPermissionList];
		// 	this.paymentPermissionList[0].state = false;
		// }

		if (
			(paymentLinksPermissionList.includes(checkItem) && itemList && checkItem.id === itemList[2].id) ||
			(paymentLinksPermissionList.includes(checkItem) && itemList && checkItem.id === itemList[1].id)
		) {
			this.virtualPosPermissionList = [...this.virtualPosPermissionList];
			this.virtualPosPermissionList[0].state = true;
			this.paymentViewPermissionList = [...this.paymentViewPermissionList];
			this.paymentViewPermissionList[0].state = true;
		}

		// if (
		// 	(checkItem.state === false && paymentLinksPermissionList.includes(checkItem) && itemList && checkItem.id === itemList[2].id) ||
		// 	(checkItem.state === false && paymentLinksPermissionList.includes(checkItem) && itemList && checkItem.id === itemList[1].id)
		// ) {
		// 	this.virtualPosPermissionList = [...this.virtualPosPermissionList];
		// 	this.virtualPosPermissionList[0].state = false;
		// 	this.paymentViewPermissionList = [...this.paymentViewPermissionList];
		// 	this.paymentViewPermissionList[0].state = false;
		// }

		if (itemList?.includes(checkItem) && checkItem !== itemList[0]) {
			itemList[0].state = true;
		}

		// if (checkItem.state === false && itemList?.includes(checkItem) && checkItem !== itemList[0] && activeItems?.length === 1) {
		// 	itemList[0].state = false;
		// }

		// if (checkItem.state === false && itemList && checkItem === itemList[0]) {
		// 	itemList.map((el) => (el.state = false));
		// }

		this.permissionList.forEach((item) => {
			item.forEach((roleItem) => {
				if (roleItem.id === checkItem.id) {
					roleItem.state = checkItem.state;
				}
			});
		});

		this.updateList();
	}

	checkboxAllChange(checkboxChangeProps: CheckAllProps) {
		this.permissionList.find((el) => el.includes(checkboxChangeProps.itemList[0]))?.forEach((item) => (item.state = checkboxChangeProps.state));
		if (checkboxChangeProps.state) {
			this.permissionList.find((el) => el.includes(checkboxChangeProps.itemList[0]))?.forEach((item) => this.checkboxChange(item));
		}
	}

	updateList() {
		this.userPermissionList = [...userPermissionList];
		this.rolePermissionList = [...rolePermissionList];
		this.virtualPosPermissionList = [...virtualPosPermissionList];
		this.paymentLinksPermissionList = [...paymentLinksPermissionList];
		this.savedCardPermissionList = [...savedCardPermissionList];
		this.supportPermissionList = [...supportPermissionList];
		this.recurringPaymentPermissionList = [...recurringPaymentPermissionList];
		this.refundPermissionList = [...refundPermissionList];
		this.paymentPermissionList = [...paymentPermissionList];
		this.terminalsPermissionList = [...terminalsPermissionList];
		this.p2pPermissionList = [...p2pPermissionList];
		this.infoPermissionList = [...infoPermissionList];
		this.paymentViewPermissionList = [...paymentViewPermissionList];
		this.analyticsPermissionList = [...analyticsPermissionList];
	}

	saveChangeRole() {
		this.isSending = true;
		let permissionList: PermissionDto[] = [];

		this.permissionList.forEach((item) => {
			item.forEach((roleItem) => {
				if (roleItem.state) {
					permissionList.push({ id: roleItem.id, name: roleItem.name });
				}
			});
		});

		const roleEditData: EditRoleDto = {
			name: this.form.get("roleName")?.value,
			privileges: permissionList,
		};

		this.roleDataService.editRole(this.roleId, roleEditData).subscribe({
			error: () => {
				this.isSending = false;
			},
			complete: () => {
				this.roleEditSuccess.emit();
				this.isSending = false;
			},
		});
	}
}
